import FilterFactory from './FilterFactory';

export default class IFilter {

  /*
 * This method build all the filters to IFilter Objects
 * @param filters {Array | Object} The filters can be passed in raw data (JSON) or IFilter objects
 **/
  buildFilters(filters) {
    if (Array.isArray(filters))
      return filters.map(filter => {
        return this.buildFilter(filter);
      });
    return this.buildFilter(filters);
  }

  /*
 * This method build all the filters to IFilter Objects
 * @param filters {Object | IFilter} The filter can be a raw data filter (JSON) or a IFilter object
 **/
  buildFilter(filter) {
    if (filter instanceof IFilter) {
      return filter;
    }
    if (filter.isFilter) {
      return filter;
    }
    return FilterFactory.factory(filter);
  }

  remove() {
    throw new Error('Not implemented yet!');
  }

  /**
   * @return {IFilter}
   * */
  clone() {
    throw new Error('Not implemented yet!');
  }

  /**
   * @return {any}
   * */
  toQuery() {
    throw new Error('Not implemented yet!');
  }

  /**
   * Converts options to a MongoDB query object.
   *
   * @param {{flat?: boolean, oid?: boolean}| undefined} An optional object containing options for the query.
   * @return {Object} - The MongoDB query object.
   */
  toMongoQuery(options) {
    throw new Error('Not implemented yet!');
  }

  get isFilter() {
    return true;
  }

  get isEmpty() {
    return false;
  }

  /**
   * @return {IFilter}
   * */
  removeFilterRecursive(filter) {
    return;
  }

  /**
   * @return {IFilter | {}}
   * */
  removeFilter(filter) {
    if (filter.type === this.type && filter.field === this.field)
      return FilterFactory.factory({});
    return this;
  }

  removeByField(filterField) {
    if (filterField === this.field)
      return FilterFactory.factory({});
    return this;
  }

  /**
   * Removes items recursively from a data structure based on the specified field.
   *
   * @param {string} filterField - The field to be used as a filter for removal.
   * @return {*} The result of the removal operation, which may vary depending on the implementation.
   */
  removeByFieldRecursive(filterField) {
    return this.removeByField(filterField);
  }
}
